export interface ListingBigQueryTable {
    listingId: string
    rows: ListingBigQueryRow[]
}

interface ListingBigQueryRow {
    tableName: string
    row: object
}

// オートロック情報
export interface RoomKeyInformation {
    al: string
    al_opening: string
    al_unlock_number: string
}

// ポスト情報
export interface RoomKeyInformation {
    post_al: string
    post_opening: string
    post_unlock_number: string
}

// ゲストキー情報
export interface RoomKeyInformation {
    guest_key_Installation_method: string
    guest_key_location: string
    guest_key_number: string
    guest_key_out_location: string
}

// スペアキー情報
export interface RoomKeyInformation {
    spare_key_Installation_method: string
    spare_key_location: string
    spare_key_number: string
    spare_key_out_location: string
}

export interface GuestKeyInformation {
    guest_key: string
}

export interface RoomWifi {
    ssid: string
    password: string
}

export const extractWifiInfo = (rows: ListingBigQueryTable["rows"]) => {
    const wifiInfo = rows.find(row => row.tableName === "room_wifi")

    if (!wifiInfo) return undefined

    return wifiInfo.row as RoomWifi
}

export interface RoomGarbageInfo {
    position_of_general_garbage_dump: string
    position_of_garbage_dump_for_private_lodging_and_key_number: string
}

export const extractRoomGarbageInfo = (rows: ListingBigQueryTable["rows"]) => {
    const garbageInfo = rows.find(row => row.tableName === "room_garbage_dumps")

    if (!garbageInfo) return undefined

    return garbageInfo.row as RoomGarbageInfo
}
